import axios from 'axios'

var newDate = new Date().toISOString().slice(0, 10).split('-')
var yearNow = parseInt(newDate[0])
if (yearNow <= 2500) { yearNow = yearNow + 543 }

const funcs = {
  rpTenYear (caseFlag, cnYear) {
    let yearEnd = yearNow - 1
    let yearStart = parseInt(yearNow) - parseInt(cnYear)
    let caseSend = caseFlag
    yearStart = yearStart + ''
    yearEnd = yearEnd + ''
    yearStart = yearStart.substring(2, 4)
    yearEnd = yearEnd.substring(2, 4)
    let sendAPI = './connectAPI/mis_forward.php?API=/api/mis/stat/v1/growth/' + caseSend + '/' + yearStart + '/' + yearEnd
    return new Promise((resolve, reject) => {
      // axios.get('/api/mis/stat/v1/growth/' + caseSend + '/' + yearStart + '/' + yearEnd)
      axios.get(sendAPI)
        .then(function (response) {
          let resData = response.data
          resolve(resData)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  rpTopTen (caseFlag, cnYear, ageRage) {
    const yy = cnYear.toString().substring(2, 4)
    let sendAPI = './connectAPI/mis_forward.php?API=/api/mis/stat/v1/topten/' + caseFlag + '/' + yy + '/' + yy + '/' + ageRage
    return new Promise((resolve, reject) => {
      // axios.get('/api/mis/stat/v1/topten/' + caseFlag + '/' + yy + '/' + yy + '/' + ageRage)
      axios.get(sendAPI)
        .then(function (response) {
          let resData = response.data
          resolve(resData)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  rpStat (caseFlag, cnYear, param) {
    let caseSend = caseFlag
    let sendAPI = './connectAPI/mis_forward.php?API=/api/mis/stat/v1/stat/' + caseSend + '/' + cnYear + '/' + param
    return new Promise((resolve, reject) => {
      // axios.get('/api/mis/stat/v1/stat/' + caseSend + '/' + cnYear + '/' + param)
      axios.get(sendAPI)
        .then(function (response) {
          let resData = response
          resolve(resData)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  rpTopTenOne (caseFlag, cnYear, ageRage) {
    let caseSend = caseFlag
    let ageSend = ageRage
    let year = cnYear.toString().substring(2, 4)
    return new Promise((resolve, reject) => {
      axios.get(`./connectAPI/mis_forward.php?API=/api/mis/stat/v1/topten/${caseSend}/${year}/${year}/${ageSend}`)
        .then(function (response) {
          let resData = response
          resolve(resData)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
export default funcs
